import React, { useCallback, useEffect, useState } from "react";

import Tabs from "../../Components/Tabs";
import Spacer from "../../Components/Spacer";
import { useNavigation, useParams } from "../../Hooks/useNavigation";

import { RagView } from "./views/rag";
import { PromptLibraryView } from "./views/prompt-library";
import { KnowledgeProjectView } from "./views/knowledge-project";

import css from "./styles.styl";

const VIEWS = {
	"prompt-library": "Prompt Library",
	rag: "Retrieval-Augmented Generation",
};

const AIParentPage = (props) => {
	const { view } = useParams();
	const navigation = useNavigation();

	const handleTabChange = (tab) => {
		switch (tab) {
			case "Prompt Library":
				navigation.navigate("/ai/prompt-library");
				break;
			case "Retrieval-Augmented Generation":
				navigation.navigate("/ai/rag");
				break;
			default:
				break;
		}
	};

	return (
		<div className={css.container}>
			<Spacer size={3} />
			<Tabs currentTab={VIEWS[view]} tabs={Object.values(VIEWS)} onChange={handleTabChange} />
			<Spacer size={2} />

			<div>
				{view === "prompt-library" ? <PromptLibraryView /> : null}
				{view === "rag" ? <RagView /> : null}
				{view === "knowledge-project" ? <KnowledgeProjectView /> : null}
			</div>
		</div>
	);
};

export default AIParentPage;
